<script>
export default {
  name: 'TabMenu',
}
</script>


<template>
  <menu class="menu">
    <!-- <header class="menu-header">
        
    </header> -->
    <body class="menu-body">
        <slot name="body"></slot>
    </body>
  </menu>
</template>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../assets/main.scss';

.menu{
  display: flex;
  margin: 40px 0 40px 0;
  padding: 0;

  // &-header{
  //   width: 7.5vw;
  //   border-bottom: solid 2px $black-light;
  // }

  &-body{
    display: flex;
    margin: 0;

    & *{
      &:nth-child(1){
          padding-left: 7vw;
          text-align: left;
      }

      @media (max-width: 1699px){
        &:nth-child(1){
          padding-left: 70px;
        }
      }
    }
  }
}

</style>
